import Link from "next/link";
import { useGetBlogPostsQuery } from "@entities/blog";
import { RouterConfig } from "@shared/lib/routerConfig";
import BlogCard from "../blog-card/blog-card";
import Container from "../container/container";
import { BlogWidgetProps } from "./types";
import classes from "./blog-widget.module.scss";

export const BlogWidget = ({ title, showAll, id }: BlogWidgetProps) => {
    const { data } = useGetBlogPostsQuery({
        count: 3,
        page: 1,
        exclude: id ?? 0
    });

    if (data) {
        return (
            <div className={classes.BlogWidget}>
                <Container>
                    <div className={classes.Header}>
                        <h2>{title}</h2>
                        {showAll && (
                            <Link href={RouterConfig.BLOG} className={classes.Link}>
                                Смотреть все
                            </Link>
                        )}
                    </div>
                    <div className={classes.Cards}>
                        {data.data.map((item) => {
                            if (item.status === "publish" && item.slug) {
                                return (
                                    <BlogCard
                                        slug={item.slug}
                                        title={item.title?.rendered ?? ""}
                                        date={item.date}
                                        image={
                                            item.x_featured_media_large ??
                                            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/up7PQAJEQNZlBQt7QAAAABJRU5ErkJggg=="
                                        }
                                        views={item.views ?? null}
                                        key={item.id}
                                    />
                                );
                            }
                        })}
                    </div>
                </Container>
            </div>
        );
    } else {
        return null;
    }
};